import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})
export class EditorEncuestaService {

  idEmpresa: string;
  idUsuario: string;
  idInstituto: string;

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.obtienInfo();
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: any = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
  }

  getIdiomasProd(idEmpresa?:string, idProducto?:string){
    this.obtienInfo();
    let idParam = idEmpresa == undefined ? this.idEmpresa : idEmpresa;
    let idParamProd = idProducto == undefined ? localStorage.getItem('productoID') : idProducto;
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getIdiomasGuardados + idParam, {productoId:idParamProd});
  }
  getJsons(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.getJsons + localStorage.getItem('productoID'));
  }
  getOneJson(jsonId:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.getOneJson + jsonId);
  }
  update(jsonId:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.update + jsonId, datos);
  }
  getJsonsConfig(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.getConfig + localStorage.getItem('productoID'));
  }
  updateConfig(jsonId:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.updateConfig + jsonId, datos);
  }
  setFlagsConfig(datos:any, idEmpresa?:string, idProducto?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    if(!idProducto){ idProducto = localStorage.getItem('productoID'); }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.flags.setCertificar + idEmpresa + "/" + idProducto, datos);
  }
  getFlagsConfig(idEmpresa?:string, idProducto?:string){
    this.obtienInfo();
    if(!idEmpresa){ idEmpresa = this.idEmpresa; }
    if(!idProducto){ idProducto = localStorage.getItem('productoID'); }
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.flags.getCertificar + idEmpresa + "/" + idProducto);
  }
  getJsonLogos(){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.getJsonLogos + localStorage.getItem('companyID') + "/" + localStorage.getItem('productoID'));
  }
  updateJsonLogos(jsonId:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.editorEncuesta.updateJsonLogos + jsonId, datos);
  }
  actualizaTextoCertificado(empresaId:string, datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.configuracionProducto.actualizaTextoCertificado + empresaId, datos);
  }
  getTextoCertificado(surveyToken:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.configuracionProducto.getTextoCertificado + surveyToken);
  }
}
